import { Card, Nav} from 'react-bootstrap'; 
import Icon from '../components/Icon/';
import React, {useContext} from 'react';
import { FileContext } from '../contexts/FileContext';

const Pricebook = () => {

    const {downloadPricebook} = useContext(FileContext);

    const handleClick = (e) => {
        console.log(e.target.getAttribute('file'));
        const file = e.target.getAttribute('file');
        downloadPricebook(file);
    }

    return (
        <>
        <Card>

          <Card.Body>
            <Card.Title>Here you can download the updated price list for the Kirisun Americas's products.</Card.Title>
            <Card.Subtitle>Last updated: 9/05/2025</Card.Subtitle>
                    <Nav className="flex-column mt-3">
                        <div className="d-flex align-items-center">
                          <Icon.PdfLogo className='ms-3' style={{width:'20px', height:'20px'}}/>
                          <Nav.Link file='Kirisun Americas Analogue Price List 2025 VER 1.4.pdf' onClick={handleClick}>2025 Kirisun Americas Dealer's Analogue price book. PDF format.</Nav.Link>
                        </div>
                        
                        <div className="d-flex align-items-center">
                          <Icon.PdfLogo className='ms-3' style={{width:'20px', height:'20px'}}/>
                          <Nav.Link file='Kirisun Americas DMR Price List 2025 VER 1.4.pdf' onClick={handleClick}>2025 Kirisun Americas Dealer's DMR price book. Excel format.</Nav.Link>
                        </div>

                        <div className="d-flex align-items-center">
                          <Icon.PdfLogo className='ms-3' style={{width:'20px', height:'20px'}}/>
                          <Nav.Link file='Kirisun Americas PTToC Price List 2025 VER 1.5.pdf' onClick={handleClick}>2025 Kirisun Americas Dealer's PTToC price book. PDF format.</Nav.Link>
                        </div>

                        <div className="d-flex align-items-center">
                          <Icon.PdfLogo className='ms-3' style={{width:'20px', height:'20px'}}/>
                          <Nav.Link file='Kirisun Americas Dual Mode Price List 2025 VER 1.2.pdf' onClick={handleClick}>2025 Kirisun Americas Dealer's Dual Mode price book. PDF format.</Nav.Link>
                        </div>
                        
                        <div className="d-flex align-items-center">
                          <Icon.ExcelLogo className='ms-3' style={{width:'20px', height:'20px'}}/>
                          <Nav.Link file='KA Price Book 2025_Dealer Excel Version_REV 1.4_9.16.2025.xlsx' onClick={handleClick}>2025 Kirisun Americas Dealer's price book. Excel format.</Nav.Link>
                        </div>
                    </Nav>
          </Card.Body>

        </Card>
        </>
    )
  
  };
  
  export default Pricebook;